import React, { SVGProps } from 'react';

const TrendingIcon = (props: SVGProps<SVGSVGElement>) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="100%"
			height="100%"
			viewBox="0 0 20 21"
			fill="none"
			{...props}
		>
			<path
				d="M7.68929 1.4086C7.96786 1.14789 8.4 1.15146 8.67857 1.41217C9.66429 2.33717 10.5893 3.3336 11.4536 4.41217C11.8464 3.89789 12.2929 3.33717 12.775 2.88003C13.0571 2.61575 13.4929 2.61575 13.775 2.8836C15.0107 4.06217 16.0571 5.61932 16.7929 7.09789C17.5179 8.55503 18 10.0443 18 11.0943C18 15.6515 14.4357 19.5015 10 19.5015C5.51429 19.5015 2 15.6479 2 11.0907C2 9.71932 2.63571 8.04432 3.62143 6.38718C4.61786 4.70503 6.025 2.95146 7.68929 1.4086ZM10.0607 16.0729C10.9643 16.0729 11.7643 15.8229 12.5179 15.3229C14.0214 14.2729 14.425 12.1729 13.5214 10.5229C13.3607 10.2015 12.95 10.18 12.7179 10.4515L11.8179 11.4979C11.5821 11.7693 11.1571 11.7622 10.9357 11.48C10.3464 10.73 9.29286 9.39075 8.69286 8.63003C8.46786 8.34432 8.03929 8.34075 7.81071 8.62646C6.60357 10.1443 5.99643 11.1015 5.99643 12.1765C6 14.6229 7.80714 16.0729 10.0607 16.0729Z"
				fill="currentColor"
			/>
		</svg>
	);
};

export default TrendingIcon;
